import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseEnvironmentSchema } from '../release-products/shapes';

export const SuggestVersionResponseSchema = z.object({
  /** Version the suggestions are bumped from; null when nothing exists yet. */
  base: z.string().nullable(),
  /** 'latest' = highest existing release in the channel; 'none' = channel empty. */
  source: z.enum(['latest', 'none']),
  /** Distinct unpublished versions above the floor, including drafts, newest first. */
  reusableVersions: z.array(z.string()),
  /** Published version in the selected channel; null when never published. */
  publishedVersion: z.string().nullable(),
  suggestions: z.object({
    major: z.string(),
    minor: z.string(),
    patch: z.string(),
  }),
});
export type SuggestVersionResponse = z.infer<typeof SuggestVersionResponseSchema>;

export const suggestVersion = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/suggest-version',
  params: z.object({}),
  query: z.object({
    productId: z.string().uuid(),
    environment: ReleaseEnvironmentSchema,
  }),
  body: z.undefined(),
  response: z.object({ data: SuggestVersionResponseSchema }),
});
